import { css, SerializedStyles } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getShipmentPanelBulkStyles = (): SerializedStyles =>
    css({ display: 'flex', flexDirection: 'column', height: '100%' });

export const getSpinnerStyles = (theme: Theme) => css({ marginTop: theme.spacing(4) });
